import {
  FETCH_VIBRATION_AGENT_METADATA_REQUEST,
  FETCH_VIBRATION_AGENT_METADATA_SUCCESS,
  FETCH_VIBRATION_AGENT_METADATA_FAILURE
} from '../actions/metadata.types';

const initialState = {
  vibrationAgent: null,
  loading: false,
  error: null
};

export default function metadataReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_VIBRATION_AGENT_METADATA_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_VIBRATION_AGENT_METADATA_SUCCESS:
      return {
        ...state,
        loading: false,
        vibrationAgent: action.metadata,
        error: null
      };

    case FETCH_VIBRATION_AGENT_METADATA_FAILURE:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
}
